import { AfterViewInit, ChangeDetectorRef, ElementRef, EventEmitter } from '@angular/core';
import { NavigationService } from '../../services/navigation/navigation.service';
import { PageNames } from '../../shared/page-names.enum';
import { ModalConfig } from '../../model/modal-config';
import { KeyDirections } from '../../shared/key-directions.enum';
import { TvshopConstants } from '../../shared/tvshop-constants';
var ConditionsModalComponent = /** @class */ (function () {
    function ConditionsModalComponent(navigationService, changeDetector) {
        this.navigationService = navigationService;
        this.changeDetector = changeDetector;
        this.emitCloseConditions = new EventEmitter();
        this.emitOnBack = new EventEmitter();
        this.componentName = PageNames.CONDITIONS_MODAL;
    }
    ConditionsModalComponent.prototype.ngAfterViewInit = function () {
        this.navigationService.resetNavigation();
        this.voorwaarden.nativeElement.focus();
        this.changeDetector.detectChanges();
    };
    ConditionsModalComponent.prototype.onEmitCloseConditions = function () {
        this.emitCloseConditions.emit({});
    };
    ConditionsModalComponent.prototype.onBack = function () {
        this.onEmitCloseConditions();
    };
    ConditionsModalComponent.prototype.onKeyDown = function (event) {
        if (event.keyCode === KeyDirections.ARROW_DOWN) {
            this.voorwaarden.nativeElement.scroll(0, this.voorwaarden.nativeElement.scrollTop + TvshopConstants.SCROLL_TEXT_AMOUNT);
        }
        if (event.keyCode === KeyDirections.ARROW_UP) {
            this.voorwaarden.nativeElement.scroll(0, this.voorwaarden.nativeElement.scrollTop - TvshopConstants.SCROLL_TEXT_AMOUNT);
        }
    };
    return ConditionsModalComponent;
}());
export { ConditionsModalComponent };
